'use client'

import { useEffect, useMemo } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18nInstance from '@/lib/i18n-client'
import { initializeI18n } from '@/lib/i18n-client'

export function I18nProvider({ children }: { children: React.ReactNode }) {
  // 使用 useMemo 确保 i18n 实例稳定
  const i18n = useMemo(() => i18nInstance, [])

  useEffect(() => {
    // 确保 i18n 已初始化
    if (!i18n.isInitialized) {
      initializeI18n().catch(console.error)
    }
  }, [i18n])

  // 使用 I18nextProvider 包装，即使在服务端也保持一致的结构
  // 这样可以避免水合不匹配
  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  )
}